import { render, staticRenderFns } from "./dataApproval.vue?vue&type=template&id=6b801581&scoped=true"
import script from "./dataApproval.vue?vue&type=script&lang=js"
export * from "./dataApproval.vue?vue&type=script&lang=js"
import style0 from "./dataApproval.vue?vue&type=style&index=0&id=6b801581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b801581",
  null
  
)

export default component.exports